"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.version = "logger/5.0.2";
